/* eslint-disable no-extra-boolean-cast */
// Dependencies
import { useSelector } from 'react-redux';
import React, { FC, ReactElement } from 'react';
// Types
import { AppState } from '../../../reducers';

type LocaleTextProps = {
    localization: any,
    default_text: string | null,
    text_key: string
};

const LocaleText: FC<LocaleTextProps> = ({localization, default_text, text_key}): ReactElement | null => {
    const main_locale = useSelector((state: AppState) => state.locale.main_locale);
    let displayed_text = default_text;
    for (let i = 0; i < (localization ?? []).length; i++) {
        if (localization[i].locale === main_locale) {
            if (!!localization[i][text_key]) {
                displayed_text = localization[i][text_key];
            }
        }
    }
    return <>{ displayed_text }</>;
};

export default LocaleText;